export default __webpack_public_path__ + "static/media/facebook.4f037d96.png";